export interface TenantConfig {
  id: string;
  name: string;
  apiUrl: string;
  theme: {
    primaryColor: string;
    secondaryColor: string;
  };
}

let currentTenant: TenantConfig | null = null;

/** Tests only: clears tenant between cases. */
export function resetTenantContextSingleton(): void {
  currentTenant = null;
}

/** Retrieves the current tenant configuration, throwing an error if not initialized. */
export function getTenant(): TenantConfig {
  if (!currentTenant) throw new Error('Tenant context not initialized');
  return currentTenant;
}

/** Sets the active tenant configuration for the application. */
export function setTenant(config: TenantConfig): void {
  currentTenant = config;
}
